/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { AssetTypes, InvestmentClass, SaleInterestPayoutPeriod, SaleStatus } from '../types/utils';
import { Category } from './category-model';
import { SaleStatusChangeLogEntry } from './sale-status-change-log-entry-model';
import { InvestmentID } from './investment-model';
import { File } from './file-model';
import { CostCalculationPercentage } from './cost-calculation-percentage-model';
import { Property } from './property-model';

export type SaleID = string;

export class Sale {
	id: SaleID = ''

	assetType: AssetTypes = AssetTypes.LOAN

	baFinId: string = ''

	company: string = ''

	corePropertyRepresentations: Array<Category> = []

	createdAt?: Date

	description: string = ''

	descriptionTitle: string = ''

	documents?: Array<File>

	endDate: Date = new Date()

	estimatedValueIncrease: number = 0

	fee: number = 0

	feeEnd: number = 0

	feeOngoing: number = 0

	firstPayoutOfInterest: Date = new Date()

	highlights: Array<string> = []

	images?: Array<File>

	interestPayoutPeriod: SaleInterestPayoutPeriod = SaleInterestPayoutPeriod.YEARLY

	interestRate: number = 0

	investmentClass: InvestmentClass = InvestmentClass.INVESTMENT_FUND

	investments?: Array<InvestmentID>

	maxPurchase?: number

	minPurchase: number = 0

	percentages: Array<CostCalculationPercentage> = []

	platformAssetValue: number = 0

	predictedPerformance: number = 0

	properties?: Array<Property>

	scoreCustomerGroup: number = 0

	scoreInvestmentClass: number = 0

	scoreWPServices: number = 0

	sharesLocked: number = 0

	sharesSold: number = 0

	startDate: Date = new Date()

	status: SaleStatus = SaleStatus.INACTIVE

	statusChangeLog?: Array<SaleStatusChangeLogEntry>

	subtitle: string = ''

	supertitle: string = ''

	title: string = ''

	totalAssetValue: number = 0

	updatedAt?: Date

	constructor(obj?: any) {
		if (obj) {
			Object.assign(
				this,
				obj
			);
		}
	}

	isSelfDisclosureRequired() : boolean {
		return this.totalAssetValue > 1000000 && this.totalAssetValue < 8000000;
	}
}